import React from 'react';

import { Button, Icon } from '@eluve/components';
import type { IconProps } from '@eluve/components';

export interface CitationChipProps {
  label: string;
  icon?: IconProps['name'];
  onClick: () => void;
  size?: 's' | 'xs';
}

export const CitationChip: React.FC<CitationChipProps> = ({
  label,
  icon = 'FileText',
  onClick,
  size = 's',
}) => (
  <Button variant="secondary" size="sm" onClick={onClick}>
    <Icon name={icon} size="auto" />
    {label}
  </Button>
);
